<template>
  <div class="component-upload-image">
    <el-upload
      multiple
      :action="uploadImgUrl"
      list-type="picture-card"
      :on-success="handleUploadSuccess"
      :before-upload="handleBeforeUpload"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      ref="imageUpload"
      :on-remove="handleDelete"
      :show-file-list="true"
      :headers="headers"
      :file-list="fileList"
      :on-preview="handlePictureCardPreview"
      :class="{hide: this.fileList.length >= this.limit}"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <!-- 上传提示 -->
    <div class="el-upload__tip" slot="tip" v-if="showTip">
      Please upload
      <template v-if="fileSize"> Not more than <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
      <template v-if="fileType"> format <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
      documents
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      title="previews"
      width="800"
      append-to-body
    >
      <img
        :src="dialogImageUrl"
        style="display: block; max-width: 100%; margin: 0 auto"
      />
    </el-dialog>
    
    <img v-if="false" :src="imageBase64" style="width: 200px;height: 200px;" alt="Image preview" />
    <canvas ref="canvas" v-if="false"></canvas>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";

export default {
  props: {
    value: [String, Object, Array],
    // 图片数量限制
    limit: {
      type: Number,
      default: 5,
    },
    // 大小限制(MB)
    fileSize: {
       type: Number,
      default: 5,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ["png", "jpg", "jpeg"],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true
    },
    isBase64:{
      type:Boolean,
      default:false
    },
    isBorder:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      hideUpload: false,
      baseUrl: process.env.VUE_APP_BASE_API?process.env.VUE_APP_BASE_API:"http://192.168.1.27:8080",
      uploadImgUrl: process.env.VUE_APP_BASE_API?process.env.VUE_APP_BASE_API+"/common/upload":"http://192.168.1.27:8080/common/upload", // 上传的图片服务器地址
      headers: {
        Authorization: "Bearer " + getToken(),
      },
      fileList: [],
      base64String:[],
      canvas: null,
      file: null,
      imageBase64: "",
    };
  },
  mounted() {
    
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : val.split(',');
          // 然后将数组转为对象数组
          this.fileList = list.map(item => {
            if (typeof item === "string") {
              let processedItem = item;
              // 如果是完整的HTTP/HTTPS URL，直接使用
              if (processedItem.startsWith('http://') || processedItem.startsWith('https://')) {
                return { name: processedItem, url: processedItem };
              }
              // 移除可能包含的/prod-api前缀
              if (processedItem.startsWith('/prod-api')) {
                processedItem = processedItem.replace('/prod-api', '');
              }
              if (processedItem.indexOf(this.baseUrl) === -1) {
                  item = { name: this.baseUrl + processedItem, url: this.baseUrl + processedItem };
              } else {
                  item = { name: processedItem, url: processedItem };
              }
            }
            return item;
          });
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    processImage(file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                // 设置canvas大小，包括边框  
                img.width = 150; img.height = 150;
                const borderWidth = 1;
                canvas.width = img.width + 2 * borderWidth;
                canvas.height = img.height + 2 * borderWidth;
                // 绘制边框  
                ctx.beginPath();
                ctx.rect(borderWidth, borderWidth, img.width, img.height);
                ctx.strokeStyle = 'rgb(148, 148, 148)'; // 边框颜色  
                ctx.lineWidth = borderWidth; // 边框宽度  
                ctx.stroke();

                // 绘制图片  
                ctx.drawImage(img, borderWidth, borderWidth, img.width, img.height);

                // 将canvas转换为Base64  
                this.imageBase64 = canvas.toDataURL('image/png'); // 或者使用'image/jpeg'  
                this.base64String.push(this.imageBase64);
            };
            img.src = e.target.result;
            // this.imageBase64=e.target.result;
        };
        reader.readAsDataURL(file);
    },
    // 上传前loading加载
    handleBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        let isImg = false;
        if(this.isBase64){
          if(this.isBorder){
            this.processImage(file);
          }else{
            const reader = new FileReader();
            reader.readAsDataURL(file);
            let that=this;
            reader.onload = () => {
              that.base64String.push(reader.result);
            };
          }
          
        }
        if (this.fileType.length) {
          let fileExtension = "";
          if (file.name.lastIndexOf(".") > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
          }
          isImg = this.fileType.some(type => {
            if (file.type.indexOf(type) > -1) return true;
            if (fileExtension && fileExtension.indexOf(type) > -1) return true;
            return false;
          });
        } else {
          isImg = file.type.indexOf("image") > -1;
        }

        if (!isImg) {
          this.$modal.msgError(`File format is not correct, please upload${this.fileType.join("/")}Picture format files!`);
          reject(new Error('File format error'));
          return;
        }
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 < this.fileSize;
          if (!isLt) {
            this.$modal.msgError(`The size of the uploaded image must not exceed ${this.fileSize} MB!`);
            reject(new Error('File size error'));
            return;
          }
        }
        // 检测文件名是否包含中文字符（包括中文、中文符号和中文空格）或空格，如果包含则使用时间戳重命名
        const hasChineseCharsOrSpaces = /[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef\s]/.test(file.name);
        let processedFile = file;
        if (hasChineseCharsOrSpaces) {
          const fileExtension = file.name.lastIndexOf(".") > -1 ? file.name.slice(file.name.lastIndexOf(".")) : "";
          const newFileName = Date.now() + fileExtension;
          // 创建新的File对象，使用新文件名
          processedFile = new File([file], newFileName, {
            type: file.type,
            lastModified: file.lastModified
          });
        }
        this.$modal.loading("Uploading pictures now, please wait...");
        this.number++;
        resolve(processedFile);
      });
    },
    // 文件个数超出
    handleExceed() {
      this.$modal.msgError(`The number of uploaded files cannot exceed ${this.limit} size!`);
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      if (res.code === 200) {
        let fileName = res.fileName;
        let fileUrl = res.fileName;
        // 移除可能包含的/prod-api前缀
        if (fileName.startsWith('/prod-api')) {
          fileName = fileName.replace('/prod-api', '');
          fileUrl = fileName;
        }
        this.uploadList.push({ name: fileName, url: fileUrl });
        this.uploadedSuccessfully();
      } else {
        this.number--;
        this.$modal.closeLoading();
        this.$modal.msgError(res.msg);
        this.$refs.imageUpload.handleRemove(file);
        this.uploadedSuccessfully();
      }
    },
    // 删除图片
    handleDelete(file) {
      const findex = this.fileList.map(f => f.name).indexOf(file.name);
      if (findex > -1) {
        this.fileList.splice(findex, 1);
        this.$emit("input", this.listToString(this.fileList));
      }
      if(this.isBase64){
        this.base64String.splice(findex, 1);
        this.$emit("updateBase64",this.base64String)
      }
    },
    // 上传失败
    handleUploadError() {
      this.$modal.msgError("Failed to upload image, please try again");
      this.$modal.closeLoading();
    },
    // 上传结束处理
    uploadedSuccessfully() {
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList);
        this.uploadList = [];
        this.number = 0;
        this.$emit("updateBase64",this.base64String)
         this.$emit("input", this.listToString(this.fileList));
        this.$modal.closeLoading();
      }
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = "";
        separator = separator || ",";
        for (let i in list) {
          if (list[i].url) {
            // 确保返回纯净的相对路径，不包含任何baseUrl或API前缀
            // 移除可能包含的完整URL前缀，只保留相对路径
            let url = list[i].url;
            // 如果是完整URL，提取相对路径
            if (url.startsWith('http://') || url.startsWith('https://')) {
              // 解析URL，获取路径部分
              const urlObj = new URL(url);
              url = urlObj.pathname;
            }
            // 移除可能包含的/prod-api前缀
            if (url.startsWith('/prod-api')) {
              url = url.replace('/prod-api', '');
            }
            // 确保路径以/开头
            if (!url.startsWith('/')) {
              url = '/' + url;
            }
            strs += url + separator;
          }
        }
        return strs != '' ? strs.substr(0, strs.length - 1) : '';
      
    }
  }
};
</script>
<style scoped lang="scss">
// .el-upload--picture-card 控制加号部分
::v-deep.hide .el-upload--picture-card {
    display: none;
}
// 去掉动画效果
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
    transition: all 0s;
}

::v-deep .el-list-enter, .el-list-leave-active {
  opacity: 0;
  transform: translateY(0);
}
</style>